(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-header-only"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('gg-page-header-visibility')){
    class GGPageHeaderVisibility extends HTMLElement{
      connectedCallback(){
        this.frame=0;
        this.schedule=this.schedule.bind(this);
        this.update=this.update.bind(this);
        this.root=this.closest('.shopify-section')||document.getElementById('shopify-section-'+this.dataset.sectionId);
        if(!this.root)return;
        this.header=this.root.querySelector('header[class*="ai-header-only__header-"]');
        this.spacer=this.root.querySelector('[class*="ai-header-only__spacer-"]');
        if(!this.header||!this.spacer)return;
        this.display=this.header.style.getPropertyValue('display');
        this.priority=this.header.style.getPropertyPriority('display');
        this.wasInert=this.header.hasAttribute('inert');
        window.addEventListener('scroll',this.schedule,{passive:true});
        document.addEventListener('scroll',this.schedule,{passive:true,capture:true});
        window.addEventListener('resize',this.schedule);
        window.addEventListener('pageshow',this.schedule);
        this.resizeObserver=new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.spacer);
        this.update();
      }
      schedule(){if(!this.frame)this.frame=requestAnimationFrame(this.update);}
      update(){
        this.frame=0;
        if(!this.isConnected||!this.header||!this.spacer)return;
        const scroller=document.scrollingElement||document.documentElement;
        const traveled=Math.max(0,window.scrollY||0,scroller.scrollTop||0,-this.spacer.getBoundingClientRect().top);
        const limit=(document.documentElement.clientHeight||window.innerHeight)*(Number(this.dataset.distance)||100)/100;
        const hide=traveled>=limit;
        const wasHidden=this.header.hasAttribute('data-scroll-hidden');
        this.header.toggleAttribute('data-scroll-hidden',hide);
        if(hide){
          if(this.header.style.getPropertyValue('display')!=='none'||this.header.style.getPropertyPriority('display')!=='important')this.header.style.setProperty('display','none','important');
          if(!this.header.hasAttribute('inert'))this.header.setAttribute('inert','');
        }else{
          if(this.display)this.header.style.setProperty('display',this.display,this.priority);
          else this.header.style.removeProperty('display');
          if(!this.wasInert)this.header.removeAttribute('inert');
          if(wasHidden){
            const bar=this.header.querySelector('[class^="ai-announcement-"]');
            if(bar&&typeof bar.refresh==='function')bar.refresh();
          }
        }
      }
      disconnectedCallback(){
        cancelAnimationFrame(this.frame);
        window.removeEventListener('scroll',this.schedule);
        document.removeEventListener('scroll',this.schedule,true);
        window.removeEventListener('resize',this.schedule);
        window.removeEventListener('pageshow',this.schedule);
        if(this.resizeObserver)this.resizeObserver.disconnect();
        if(!this.header)return;
        this.header.removeAttribute('data-scroll-hidden');
        if(this.display)this.header.style.setProperty('display',this.display,this.priority);
        else this.header.style.removeProperty('display');
        if(!this.wasInert)this.header.removeAttribute('inert');
      }
    }
    customElements.define('gg-page-header-visibility',GGPageHeaderVisibility);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
